export default function AssessmentSideSelector({
    selectedSide,
    setSelectedSide,
    location
}) {
    return (
        <div 
            className={`
                flex justify-center items-center gap-x-4
                ${location === 'bottom' ? 'pt-2' : ''}
            `}
        >

            <div 
                className={`
                    flex-1 text-left text-sm text-gray-500 cursor-pointer
                    ${selectedSide === 'left' ? 'font-bold' : ''}
                    ${selectedSide === 'left' ? 'text-orange-400' : 'text-orange-300'}

                `} 
                onClick={() => setSelectedSide('left')}
            >
                Left Side
            </div>

            <div 
                className={`
                    flex-1 text-right text-sm text-gray-500 cursor-pointer
                    ${selectedSide === 'right' ? 'font-bold' : ''}
                    ${selectedSide === 'right' ? 'text-orange-400' : 'text-orange-300'}

                `} 
                onClick={() => setSelectedSide('right')}
            >
                Right Side
            </div>

        </div>
    )
}